import { render } from "./ClimateChangeSeaCortesBlog.vue?vue&type=template&id=35753624&scoped=true"
import script from "./ClimateChangeSeaCortesBlog.vue?vue&type=script&lang=js"
export * from "./ClimateChangeSeaCortesBlog.vue?vue&type=script&lang=js"

import "./ClimateChangeSeaCortesBlog.vue?vue&type=style&index=0&id=35753624&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35753624"]])

export default __exports__